module.exports = __webpack_public_path__ + "static/img/downloadLogo.ecbc0500.png";